export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";


// WEBPACK FOOTER //
// ./src/constants/userActionTypes.js